import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
  }

  componentWillMount() {
    this.delayedCallback = _.debounce(e => {
      this.handleParentChange(e);
    }, this.props.wait);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ value: this.props.value });
    }
  }

  componentWillUnmount() {
    this.delayedCallback.cancel();
  }

  handleParentChange = e => {
    if (this.props.value !== this.state.value) this.props.onChange(e);
  };

  handleInputChange = event => {
    event.persist();
    this.setState({ value: event.target.value });
    this.delayedCallback(event);
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleParentChange(e);
    }
  };

  render() {
    return (
      <input
        {...this.props}
        value={this.state.value || ''}
        onChange={this.handleInputChange}
        onKeyPress={this.handleKeyPress}
      />
    );
  }
}

SearchInput.defaultProps = {
  value: '',
  wait: 800
};

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  wait: PropTypes.number
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/SearchInput/SearchInput.js